<div class="container mx-auto" style="max-width: 740px;">
	<div class="divisa-row">
    <app-back-button class="divisa-col-md-8 divisa-col-12 mx-auto" [title]="'SHARED.RESERVATION_FOREIGN_CURRENCY_TITLE' | translate"></app-back-button>
	</div>
	<div class="divisa-row mx-2 mb-4 mt-3">
	  <div class="divisa-col-12">
		  <p class="cuerpo text-center pt-2"><span class="text-color-danger">{{ 'SHARED.LABEL_EXPIRED' | translate }}</span>
        {{
          'SHARED.EXPIRED_AT'
            | translate
              : {
                  time: (reservacion.createdAt | date : 'HH:mm'),
                  date: (reservacion.createdAt | date : 'dd/MM/yyyy')
                }
        }}</p>
	  </div>
	</div>
	  <app-reservacion [pagarTexto]="'SHARED.PAY_PENDING' | translate" [recibiTexto]="'SHARED.RECEIVE_PENDING' | translate" [cotizacion]="cotizacion" [typoCard]="'vencida'"></app-reservacion>
  <div class="divisa-row mt-2 px-3 px-md-0">
    <div class="divisa-row subtitulo mt-4 mb-2">
      {{ 'SHARED.BRANCH_SECTION' | translate }}
    </div>
	  <div class="divisa-row sucursal-card">
      <div class="col-3 col-md-1 my-auto">
        <img class="icon-divisas" src="./assets/img/circle-icon.svg" alt="">
      </div>
      <div class="col-9 col-md-3 my-auto">
        <span class="sucursal-name">{{ reservacion.idBranch.branchName }}</span> <br>
        <span class="sucursal-locality">{{ reservacion.idBranch.addresses.state }}</span>
      </div>
      <div class="col my-auto" style="display: inline-flex;">
        <span class="sucursal-address">
          {{ reservacion.idBranch.addresses.street }},
          {{ reservacion.idBranch.addresses.sublocality }},
          {{ reservacion.idBranch.addresses.zipCode }}
          {{ reservacion.idBranch.addresses.locality }},
          {{ reservacion.idBranch.addresses.state }}
        </span>
      </div>
      <div class="col-1 p-0 my-auto">
        <mat-icon color="accent" svgIcon="fmd_good"></mat-icon>
      </div>
	  </div>
	</div>

	<div class="row mt-5 mx-0">
	  <div class="d-flex divisa-col-12 divisa-col-md-3 justify-content-center mb-4 mb-md-0 px-md-0">
		  <qrcode [qrdata]="reservacion.order" [width]="144" [errorCorrectionLevel]="'H'" [margin]="1"></qrcode>
	  </div>
    <div class="divisa-col-12 divisa-col-md-9 p-md-0 px-3">
      <div class="divisa-row">
        <p class="cuerpo">{{ 'SHARED.RESERVATION_CODE' | translate }}</p>
      </div>
      <div class="divisa-row">
        <h6 class="text-color-primary">{{ reservacion.order }}</h6>
      </div>
      <!-- <div class="divisa-row">
        <div class="divisa-col-6 divisa-row">
          <img class="icon-divisas" src="./assets/img/circle-icon-primary.svg" alt="">
          <h6 class="m-1 ml-1">{{ reservacion.quotation?.calculatedPoints ?? 0 }} pts</h6>
        </div>
        <div class="divisa-col-6 divisa-row">
          <p class="divisa-col cuerpo text-right pr-3">Se generarán con esta transacción</p>
            <button class="icon-button-secondary active"  mat-mini-fab color="primary" aria-label="Los puntos generados">
              <mat-icon svgIcon="question_mark"></mat-icon>
            </button>
        </div>
      </div> -->
    </div>
	</div>
	<div class="row mt-4">
    <!-- <button class="btn btn-outline-light col-12 col-md-6 mx-auto"  type="button"> -->
    <button class="btn btn-outline-light col-12 col-md-6 mx-auto" type="button" (click)="atras()">

      {{ 'SHARED.BACK_TO_HISTORY' | translate }}
    </button>
	</div>
</div>
